import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: max(100vh, 100%);
  background-color: ${({ theme }) => theme.colors.primaryDark};
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
`;

export const Logo = styled.img`
  width: 22px;
`;

export const ItemContainer = styled.div`
  ${({ pushToEnd }) => pushToEnd && 'margin-top: auto;'}
`;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;

  ${({ selected, theme }) =>
    selected &&
    `
    background-color: ${theme.colors.primaryMedium};
    box-shadow: inset 3px 0 0 ${theme.colors.white};
  `}

  &:hover {
    cursor: pointer;
  }

  &:before {
    content: ${({ icon }) => icon};
    font-family: Icomoon;
    font-size: 22px;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Item = styled(typography.BodyTextThreeRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
`;
